class WeQuantityDropdown {
  constructor(quantityInput) {
    this.quantityInput = quantityInput;
    this.input = quantityInput.querySelector('input.quantity__input');
    this.select = quantityInput.querySelector('.we-quantity-dropdown__select');

    if (!this.input || !this.select) return;

    this.sectionId = quantityInput.getAttribute('data-section-id');
    this.productId = quantityInput.getAttribute('data-product-id');
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.select.addEventListener('change', this.onSelectChange.bind(this), { signal });
    this.input.addEventListener('change', this.syncSelectToInput.bind(this), { signal });

    if (typeof theme !== 'undefined' && theme.pubsub?.PUB_SUB_EVENTS) {
      this.quantityRulesUnsubscriber = theme.pubsub.subscribe(
        theme.pubsub.PUB_SUB_EVENTS.quantityRules,
        this.onQuantityRules.bind(this)
      );
      this.quantityBoundriesUnsubscriber = theme.pubsub.subscribe(
        theme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
        this.onQuantityBoundries.bind(this)
      );
    }
  }

  destroy() {
    this.abortController.abort();
    this.quantityRulesUnsubscriber?.();
    this.quantityBoundriesUnsubscriber?.();
  }

  onSelectChange() {
    const nextValue = parseInt(this.select.value, 10);
    if (Number.isNaN(nextValue) || this.input.value === String(nextValue)) return;

    this.input.value = nextValue;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  syncSelectToInput() {
    const value = parseInt(this.input.value, 10);
    if (Number.isNaN(value)) return;

    if (!this.select.querySelector(`option[value="${value}"]`)) {
      this.rebuildOptions();
    }

    this.select.value = String(value);
  }

  onQuantityRules({ data }) {
    if (data.sectionId !== this.sectionId || data.productId !== this.productId) return;
    setTimeout(() => {
      this.rebuildOptions();
      this.syncSelectToInput();
    }, 0);
  }

  onQuantityBoundries({ data }) {
    if (data.sectionId !== this.sectionId || data.productId !== this.productId) return;
    setTimeout(() => {
      this.rebuildOptions();
      this.syncSelectToInput();
    }, 0);
  }

  getEffectiveMax() {
    const min = parseInt(this.input.getAttribute('data-min') || this.input.min || '1', 10);
    const step = parseInt(this.input.getAttribute('step') || '1', 10);
    const cartQuantity = parseInt(this.input.getAttribute('data-cart-quantity') || '0', 10);
    const dataMax = this.input.hasAttribute('data-max')
      ? parseInt(this.input.getAttribute('data-max'), 10)
      : null;

    let max = dataMax;
    if (max !== null) {
      max = max - cartQuantity;
    }

    if (max === null) {
      return min + step * 9;
    }

    return max;
  }

  rebuildOptions() {
    const min = parseInt(this.input.getAttribute('data-min') || this.input.min || '1', 10);
    const step = parseInt(this.input.getAttribute('step') || '1', 10);
    const effectiveMax = this.getEffectiveMax();
    const currentValue = parseInt(this.input.value || min, 10);

    this.select.innerHTML = '';

    let value = min;
    let count = 0;

    while (value <= effectiveMax && count < 10) {
      const option = document.createElement('option');
      option.value = String(value);
      option.textContent = String(value);
      if (value === currentValue) option.selected = true;
      this.select.appendChild(option);

      value += step;
      count += 1;
    }

    this.select.value = String(currentValue);
  }
}

function initializeWeQuantityDropdowns(root = document) {
  root.querySelectorAll('quantity-input.we-quantity-dropdown').forEach((quantityInput) => {
    if (quantityInput._weQuantityDropdown) return;
    quantityInput._weQuantityDropdown = new WeQuantityDropdown(quantityInput);
  });
}

if (typeof window !== 'undefined') {
  window.WeQuantityDropdown = WeQuantityDropdown;
  window.initializeWeQuantityDropdowns = initializeWeQuantityDropdowns;

  document.addEventListener('DOMContentLoaded', () => initializeWeQuantityDropdowns());

  if (typeof theme !== 'undefined' && theme.pubsub?.PUB_SUB_EVENTS) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(() => initializeWeQuantityDropdowns(), 50);
    });
  }
}
